import React, { useState } from 'react';
import { LegalModals } from './LegalModals';
export function Footer() {
  const [modalType, setModalType] = useState<'terms' | 'privacy' | 'refund' | null>(null);
  const openModal = (e: React.MouseEvent, type: 'terms' | 'privacy' | 'refund') => {
    e.preventDefault();
    setModalType(type);
  };
  return <>
      <footer className="bg-primary border-t border-secondary" data-id="element-36">
        <div className="max-w-7xl mx-auto px-4 md:px-12 py-12 md:py-16" data-id="element-37">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-12 text-center sm:text-left" data-id="element-38">
            {/* Column 1 */}
            <div className="space-y-4" data-id="element-39">
              <div className="text-gold font-playfair font-bold text-2xl" data-id="element-40">
                VitalyForms
              </div>
              <div className="font-inter font-light text-warm-muted text-xs tracking-widest uppercase" data-id="element-41">
                La Ciencia de la Transformación Personal
              </div>
              <p className="font-inter text-warm-muted text-sm leading-relaxed" data-id="element-42">
                Sistemas basados en neuroplasticidad y regulación somática.
              </p>
            </div>

            {/* Column 2 */}
            <div data-id="element-43">
              <h4 className="font-inter font-bold text-gold text-xs tracking-widest uppercase mb-4 md:mb-6" data-id="element-44">
                PRODUCTO
              </h4>
              <ul className="space-y-3 font-inter text-sm text-warm-muted" data-id="element-45">
                <li data-id="element-46">
                  <a href="#" className="hover:text-gold transition-colors" data-id="element-47">
                    El Protocolo RNS
                  </a>
                </li>
                <li data-id="element-48">
                  <a href="#" className="hover:text-gold transition-colors" data-id="element-49">
                    Qué incluye
                  </a>
                </li>
                <li data-id="element-50">
                  <a href="#" className="hover:text-gold transition-colors" data-id="element-51">
                    Para quién es
                  </a>
                </li>
                <li data-id="element-52">
                  <a href="#" className="hover:text-gold transition-colors" data-id="element-53">
                    Preguntas frecuentes
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 */}
            <div data-id="element-54">
              <h4 className="font-inter font-bold text-gold text-xs tracking-widest uppercase mb-4 md:mb-6" data-id="element-55">
                LEGAL
              </h4>
              <ul className="space-y-3 font-inter text-sm text-warm-muted" data-id="element-56">
                <li data-id="element-57">
                  <a href="#" onClick={e => openModal(e, 'terms')} className="hover:text-gold transition-colors" data-id="element-58">
                    Términos y Condiciones
                  </a>
                </li>
                <li data-id="element-59">
                  <a href="#" onClick={e => openModal(e, 'privacy')} className="hover:text-gold transition-colors" data-id="element-60">
                    Política de Privacidad
                  </a>
                </li>
                <li data-id="element-61">
                  <a href="#" onClick={e => openModal(e, 'refund')} className="hover:text-gold transition-colors" data-id="element-62">
                    Política de Reembolso
                  </a>
                </li>
                <li data-id="element-63">
                  <a href="#" className="hover:text-gold transition-colors" data-id="element-64">
                    Aviso Legal
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bg-footer border-t border-secondary py-5 md:py-6 px-4 md:px-12" data-id="element-65">
          <div className="max-w-7xl mx-auto flex flex-col items-center gap-3 md:flex-row md:justify-between md:gap-4 font-inter font-light text-xs text-warm-disabled text-center" data-id="element-66">
            <div data-id="element-67">© 2026 VitalyForms. Todos los derechos reservados.</div>
            <div data-id="element-68">
              Producto educativo. No constituye asesoramiento médico ni
              financiero.
            </div>
            <div className="space-x-3" data-id="element-69">
              <a href="#" onClick={e => openModal(e, 'privacy')} className="hover:text-warm-muted transition-colors" data-id="element-70">
                Privacidad
              </a>
              <span data-id="element-71">·</span>
              <a href="#" onClick={e => openModal(e, 'terms')} className="hover:text-warm-muted transition-colors" data-id="element-72">
                Términos
              </a>
              <span data-id="element-73">·</span>
              <a href="#" onClick={e => openModal(e, 'refund')} className="hover:text-warm-muted transition-colors" data-id="element-74">
                Reembolso
              </a>
            </div>
          </div>
        </div>
      </footer>

      <LegalModals isOpen={modalType !== null} type={modalType} onClose={() => setModalType(null)} data-id="element-75" />
    </>;
}